import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import CurrencyInput from 'shared/inputs/CurrencyInput';
import PercentInput from 'shared/inputs/PercentInput';
import PhoneInput from 'shared/inputs/PhoneInput';
import SSNInput from 'shared/inputs/SSNInput';
import Icon from 'shared/icons/IconComponent';
import RequiredMark from 'shared/inputs/RequiredMark';
import get from 'lodash/get';

/**
 * @deprecated Use Telerik or shared components instead.
 */
const FormikInput = forwardRef(
  (
    {
      errors,
      touched,
      label,
      customInput = '',
      wrapperClass,
      quickAddClick = null,
      quickAddIcon = 'plus-circle',
      errorMessage = '',
      touchedNested = false,
      ...inputProps
    },
    ref,
  ) => {
    const hasError = (errorMessage || get(errors, inputProps.name)) && (touchedNested || get(touched, inputProps.name));
    const CustomInput = customInput === 'currency' ? CurrencyInput
      : customInput === 'percent' ? PercentInput
        : customInput === 'phone' ? PhoneInput
          : SSNInput;
    const input = !customInput ? (
      <input
        id={inputProps.name}
        ref={ref}
        className={hasError ? 'error' : ''}
        autoComplete={
          label
            ? label.indexOf(' ') > 0
              ? `${label.toLowerCase().replace(/ /g, '-')}`
              : `new-${label.toLowerCase()}`
            : undefined
        }
        {...inputProps}
        value={inputProps.value === null ? '' : inputProps.value}
      />
    ) : (
      <CustomInput
        id={inputProps.name}
        ref={ref}
        className={hasError ? 'error' : ''}
        autoComplete={
          label
            ? label.indexOf(' ') > 0
              ? `${label.toLowerCase().replace(/ /g, '-')}`
              : `new-${label.toLowerCase()}`
            : undefined
        }
        {...inputProps}
      />
    );

    return (
      <div className={`formik-wrapper ${wrapperClass || ''}`}>
        <label htmlFor={inputProps.name}>
          {label}
          {inputProps.required ? <RequiredMark /> : null}
        </label>
        {quickAddClick ? (
          <div className='input-items-container'>
            {input}
            <button className='button secondary text-align--center margin--off' onClick={quickAddClick} type='button'>
              <Icon icon={quickAddIcon} position='none' className='icon--adjust-top font-size--large' />
            </button>
          </div>
        ) : (
          input
        )}
        {hasError && <div className='feedback'>{errorMessage || get(errors, inputProps.name)}</div>}
      </div>
    );
  },
);

FormikInput.propTypes = {
  errors: PropTypes.object,
  touched: PropTypes.object,
  label: PropTypes.string,
  inputProps: PropTypes.object,
  customInput: PropTypes.string,
  wrapperClass: PropTypes.string,
};

export default FormikInput;
